import React from "react";
import { Paper, Button } from "@mui/material";

export function VizCard({
  viz,
  onPlace,      // for brand-new visuals
  onApply,      // for replacements
  onEdit,
  onDiscard
}) {
  return (
    <Paper sx={{ p: 2, mb: 2 }}>
      <iframe src={viz.displayLink} width="100%" height="400" style={{ border:0 }} />
      <div style={{ display:"flex", gap:8, marginTop:8 }}>
        {onPlace && (
          <Button size="small" variant="contained" onClick={() => onPlace(viz.id)}>
            Place Visualization
          </Button>
        )}
        {onApply && (
          <Button size="small" variant="contained" onClick={() => onApply(viz.id)}>
            Apply Update
          </Button>
        )}
        <Button size="small" onClick={() => onEdit(viz)}>Edit Prompt</Button>
        <Button size="small" variant="outlined" color="error" onClick={() => onDiscard(viz.id)}>
          Discard
        </Button>
      </div>
    </Paper>
  );
}
